// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Medical theme custom styles */
.medical-gradient {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
}

.medical-card-hover {
  transition: all 0.3s ease;
}

.medical-card-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.15);
}

/* Product Description Styles - Mobile First & SEO Optimized */
.product-description {
  line-height: 1.75;
  color: #374151;
}

.product-description h1,
.product-description h2,
.product-description h3,
.product-description h4 {
  scroll-margin-top: 80px; /* For sticky headers */
  line-height: 1.3;
}

.product-description h2 {
  margin-top: 2rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #BFDBFE;
}

.product-description h3 {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
}

.product-description p {
  margin-bottom: 1rem;
}

.product-description ul,
.product-description ol {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.product-description li {
  margin-bottom: 0.5rem;
}

.product-description table {
  width: 100%;
  margin: 1.5rem 0;
  border-collapse: collapse;
  overflow-x: auto;
  display: block;  
}

@media (min-width: 640px) {
  .product-description table {
    display: table;
  }
}

.product-description th,
.product-description td {
  padding: 0.75rem;
  text-align: left;
  border: 1px solid #E5E7EB;
}

.product-description th {
  background-color: #DBEAFE;
  font-weight: 600;
}

.product-description blockquote {
  margin: 1.5rem 0;
  padding: 1rem;
  padding-left: 1rem;
  background-color: #EFF6FF;
  border-left: 4px solid #3B82F6;
  font-style: italic;
}

.product-description img {
  max-width: 100%;
  height: auto;
  border-radius: 0.5rem;
  margin: 1rem 0;
}

.product-description a {
  color: #2563EB;
  text-decoration: underline;
  transition: color 0.2s;
}

.product-description a:hover {
  color: #1E40AF;
}

/* Mobile optimization for long text */
@media (max-width: 640px) {
  .product-description {
    font-size: 0.9375rem; /* 15px */
  }
  
  .product-description h2 {
    font-size: 1.25rem; /* 20px */
  }
  
  .product-description h3 {
    font-size: 1.125rem; /* 18px */
  }
  
  .product-description ul,
  .product-description ol {
    padding-left: 1.25rem;
  }
}

  /* Healing minimal product detail theme */
  .healing-background {
    background: radial-gradient(circle at top, #f1f6fb, #e7f1f5 45%, #dde8ef);
  }

  .healing-card {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 1.5rem;
    padding: 1.5rem;
    box-shadow: 0 25px 60px rgba(26, 46, 64, 0.08);
    border: 1px solid rgba(15, 76, 117, 0.05);
    -webkit-backdrop-filter: blur(12px);
            backdrop-filter: blur(12px);
  }

  .healing-subtle-panel {
    background: rgba(243, 248, 251, 0.9);
    border-radius: 1.25rem;
    padding: 1.25rem;
    border: 1px solid rgba(15, 76, 117, 0.06);
  }

  .healing-badge {
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    background: rgba(15, 76, 117, 0.85);
    color: #fff;
    font-size: 0.65rem;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    padding: 0.4rem 0.75rem;
    border-radius: 999px;
  }

  .healing-pill-badge {
    background: rgba(255, 255, 255, 0.95);  
    color: #0f4c75; 
    padding: 0.4rem 1rem;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 600;
    box-shadow: inset 0 0 0 1px rgba(15, 76, 117, 0.1);
  }

  .healing-chip {
    padding: 0.35rem 0.9rem;
    border-radius: 999px;
    background: rgba(15, 76, 117, 0.08);
    color: #0f4c75;
    font-weight: 500;
    font-size: 0.78rem;
  }

  .healing-primary-btn {
    background: linear-gradient(120deg, #4cb8c4, #3cd3ad);
    color: #fff;
    border: none;
    border-radius: 999px;
    padding: 0.9rem 2.5rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 10px 25px rgba(60, 211, 173, 0.4);
  }c

  .healing-primary-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 30px rgba(60, 211, 173, 0.4);
  }

  .healing-secondary-btn {
    background: rgba(15, 76, 117, 0.08);
    color: #0f4c75;
    border-radius: 999px;
    padding: 0.45rem 1.5rem;
    font-size: 0.85rem;
    font-weight: 600;
    transition: background 0.2s ease;
  }

  .healing-secondary-btn:hover {
    background: rgba(15, 76, 117, 0.15);
  }

  .healing-pill-tab {
    border-radius: 999px;
    padding: 0.65rem 1.5rem;
    font-size: 0.9rem;
    font-weight: 600;
    color: rgba(15, 76, 117, 0.6);
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid transparent;
    transition: all 0.2s ease;
  }

  .healing-pill-tab.is-active {
    background: #ffffff;
    color: #0f4c75;
    border-color: rgba(15, 76, 117, 0.15);
    box-shadow: 0 10px 25px rgba(15, 76, 117, 0.15);
  }

  .healing-check {
    display: inline-flex;
    width: 0.65rem;
    height: 0.65rem;
    margin-right: 0.65rem;
    border-radius: 999px;
    background: linear-gradient(120deg, #4cb8c4, #3cd3ad);
  }

  .healing-metric {
    padding: 0.75rem 0.5rem;
    border-bottom: 1px solid rgba(15, 76, 117, 0.07);
  }

  .healing-metric:last-child {
    border-bottom: none;
  }

  .metric-label {
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.4em;
    color: rgba(15, 76, 117, 0.45);
    margin-bottom: 0.35rem;
  }

  .metric-value {
    font-size: 1.05rem;
    color: #0f4c75;
    font-weight: 500;
  }

  .healing-table {
    border-collapse: collapse;
    width: 100%;
    min-width: 520px;
  }

  .healing-table th,
  .healing-table td {
    text-align: left;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid rgba(15, 76, 117, 0.08);
    font-size: 0.9rem;
    color: #0f4c75;
  }

  .healing-table thead th {
    font-size: 0.75rem;
    letter-spacing: 0.35em;
    text-transform: uppercase;
    color: rgba(15, 76, 117, 0.45);
    border-bottom: 1px solid rgba(15, 76, 117, 0.15);
  }

  .healing-select {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(15, 76, 117, 0.15);
    border-radius: 999px;
    padding: 0.35rem 0.75rem;
    font-size: 0.85rem;
    color: #0f4c75;
  }

  .healing-subtle-panel ul li span:last-child,
  .healing-subtle-panel ul li strong {
    font-weight: 600;
  }

  .healing-subtle-panel ul li strong {
    color: #0f4c75;
  }

  .healing-subtle-panel ul li span:first-child {
    color: rgba(15, 76, 117, 0.6);
  }

  .healing-subtle-panel ul li {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .healing-background .healing-card h1,
  .healing-background h2,
  .healing-background h3,
  .healing-background h4 {
    color: #0f4c75;
  }

  .healing-select:focus,
  .healing-pill-tab:focus,
  .healing-primary-btn:focus,
  .healing-secondary-btn:focus {
    outline: 2px solid rgba(76, 184, 196, 0.5);
    outline-offset: 2px;
  }

  .healing-card .metric-value {
    font-family: 'Inter', 'Segoe UI', sans-serif;
  }

  .healing-card,
  .healing-subtle-panel {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .healing-card:hover,
  .healing-subtle-panel:hover {
    transform: translateY(-1px);
    box-shadow: 0 35px 60px rgba(13, 38, 59, 0.08);
  }

  .healing-card .metric-label {
    font-family: 'Inter', 'Segoe UI', sans-serif;
  }

  .healing-tab-content {
    background: rgba(255, 255, 255, 0.92);
    border-radius: 1.25rem;
    border: 1px solid rgba(15, 76, 117, 0.06);
  }

  .healing-tab-content + .healing-tab-content {
    margin-top: 1.5rem;
  }

  .healing-muted-text {
    color: rgba(15, 76, 117, 0.6);
  }

  .healing-ink,
  .text-healing-ink {
    color: #0f4c75;
  }

  .text-healing-ink-60 {
    color: rgba(15, 76, 117, 0.6);
  }

  .text-healing-ink-70 {
    color: rgba(15, 76, 117, 0.7);
  }

  .text-healing-ink-80 {
    color: rgba(15, 76, 117, 0.8);
  }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,8DAA8D;AAC9D;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;EAIE,uBAAuB,EAAE,uBAAuB;EAChD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE;IACE,oBAAoB,EAAE,SAAS;EACjC;;EAEA;IACE,kBAAkB,EAAE,SAAS;EAC/B;;EAEA;IACE,mBAAmB,EAAE,SAAS;EAChC;;EAEA;;IAEE,qBAAqB;EACvB;AACF;;EAEE,yCAAyC;EACzC;IACE,yEAAyE;EAC3E;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;IACrB,eAAe;IACf,8CAA8C;IAC9C,yCAAyC;IACzC,mCAA2B;YAA3B,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,cAAc;IACd,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,kDAAkD;EACpD;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;IACpB,mCAAmC;IACnC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,qDAAqD;IACrD,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,qDAAqD;IACrD,+CAA+C;EACjD,CAAC;;;IAGC,2BAA2B;IAC3B,+CAA+C;EACjD;;EAEA;IACE,mCAAmC;IACnC,cAAc;IACd,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,oCAAoC;IACpC,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qCAAqC;IACrC,+CAA+C;EACjD;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,qDAAqD;EACvD;;EAEA;IACE,uBAAuB;IACvB,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,qBAAqB;IACrB,gDAAgD;IAChD,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,gDAAgD;EAClD;;EAEA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,oBAAoB;IACpB,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;;;;IAIE,cAAc;EAChB;;EAEA;;;;IAIE,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;;IAEE,qDAAqD;EACvD;;EAEA;;IAEE,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,qCAAqC;IACrC,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B","sourcesContent":["/* Medical theme custom styles */\n.medical-gradient {\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n}\n\n.medical-card-hover {\n  transition: all 0.3s ease;\n}\n\n.medical-card-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.15);\n}\n\n/* Product Description Styles - Mobile First & SEO Optimized */\n.product-description {\n  line-height: 1.75;\n  color: #374151;\n}\n\n.product-description h1,\n.product-description h2,\n.product-description h3,\n.product-description h4 {\n  scroll-margin-top: 80px; /* For sticky headers */\n  line-height: 1.3;\n}\n\n.product-description h2 {\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #BFDBFE;\n}\n\n.product-description h3 {\n  margin-top: 1.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.product-description p {\n  margin-bottom: 1rem;\n}\n\n.product-description ul,\n.product-description ol {\n  margin: 1rem 0;\n  padding-left: 1.5rem;\n}\n\n.product-description li {\n  margin-bottom: 0.5rem;\n}\n\n.product-description table {\n  width: 100%;\n  margin: 1.5rem 0;\n  border-collapse: collapse;\n  overflow-x: auto;\n  display: block;  \n}\n\n@media (min-width: 640px) {\n  .product-description table {\n    display: table;\n  }\n}\n\n.product-description th,\n.product-description td {\n  padding: 0.75rem;\n  text-align: left;\n  border: 1px solid #E5E7EB;\n}\n\n.product-description th {\n  background-color: #DBEAFE;\n  font-weight: 600;\n}\n\n.product-description blockquote {\n  margin: 1.5rem 0;\n  padding: 1rem;\n  padding-left: 1rem;\n  background-color: #EFF6FF;\n  border-left: 4px solid #3B82F6;\n  font-style: italic;\n}\n\n.product-description img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 0.5rem;\n  margin: 1rem 0;\n}\n\n.product-description a {\n  color: #2563EB;\n  text-decoration: underline;\n  transition: color 0.2s;\n}\n\n.product-description a:hover {\n  color: #1E40AF;\n}\n\n/* Mobile optimization for long text */\n@media (max-width: 640px) {\n  .product-description {\n    font-size: 0.9375rem; /* 15px */\n  }\n  \n  .product-description h2 {\n    font-size: 1.25rem; /* 20px */\n  }\n  \n  .product-description h3 {\n    font-size: 1.125rem; /* 18px */\n  }\n  \n  .product-description ul,\n  .product-description ol {\n    padding-left: 1.25rem;\n  }\n}\n\n  /* Healing minimal product detail theme */\n  .healing-background {\n    background: radial-gradient(circle at top, #f1f6fb, #e7f1f5 45%, #dde8ef);\n  }\n\n  .healing-card {\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 1.5rem;\n    padding: 1.5rem;\n    box-shadow: 0 25px 60px rgba(26, 46, 64, 0.08);\n    border: 1px solid rgba(15, 76, 117, 0.05);\n    backdrop-filter: blur(12px);\n  }\n\n  .healing-subtle-panel {\n    background: rgba(243, 248, 251, 0.9);\n    border-radius: 1.25rem;\n    padding: 1.25rem;\n    border: 1px solid rgba(15, 76, 117, 0.06);\n  }\n\n  .healing-badge {\n    position: absolute;\n    top: 0.75rem;\n    left: 0.75rem;\n    background: rgba(15, 76, 117, 0.85);\n    color: #fff;\n    font-size: 0.65rem;\n    letter-spacing: 0.3em;\n    text-transform: uppercase;\n    padding: 0.4rem 0.75rem;\n    border-radius: 999px;\n  }\n\n  .healing-pill-badge {\n    background: rgba(255, 255, 255, 0.95);  \n    color: #0f4c75; \n    padding: 0.4rem 1rem;\n    border-radius: 999px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    box-shadow: inset 0 0 0 1px rgba(15, 76, 117, 0.1);\n  }\n\n  .healing-chip {\n    padding: 0.35rem 0.9rem;\n    border-radius: 999px;\n    background: rgba(15, 76, 117, 0.08);\n    color: #0f4c75;\n    font-weight: 500;\n    font-size: 0.78rem;\n  }\n\n  .healing-primary-btn {\n    background: linear-gradient(120deg, #4cb8c4, #3cd3ad);\n    color: #fff;\n    border: none;\n    border-radius: 999px;\n    padding: 0.9rem 2.5rem;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    box-shadow: 0 10px 25px rgba(60, 211, 173, 0.4);\n  }c\n\n  .healing-primary-btn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 18px 30px rgba(60, 211, 173, 0.4);\n  }\n\n  .healing-secondary-btn {\n    background: rgba(15, 76, 117, 0.08);\n    color: #0f4c75;\n    border-radius: 999px;\n    padding: 0.45rem 1.5rem;\n    font-size: 0.85rem;\n    font-weight: 600;\n    transition: background 0.2s ease;\n  }\n\n  .healing-secondary-btn:hover {\n    background: rgba(15, 76, 117, 0.15);\n  }\n\n  .healing-pill-tab {\n    border-radius: 999px;\n    padding: 0.65rem 1.5rem;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: rgba(15, 76, 117, 0.6);\n    background: rgba(255, 255, 255, 0.8);\n    border: 1px solid transparent;\n    transition: all 0.2s ease;\n  }\n\n  .healing-pill-tab.is-active {\n    background: #ffffff;\n    color: #0f4c75;\n    border-color: rgba(15, 76, 117, 0.15);\n    box-shadow: 0 10px 25px rgba(15, 76, 117, 0.15);\n  }\n\n  .healing-check {\n    display: inline-flex;\n    width: 0.65rem;\n    height: 0.65rem;\n    margin-right: 0.65rem;\n    border-radius: 999px;\n    background: linear-gradient(120deg, #4cb8c4, #3cd3ad);\n  }\n\n  .healing-metric {\n    padding: 0.75rem 0.5rem;\n    border-bottom: 1px solid rgba(15, 76, 117, 0.07);\n  }\n\n  .healing-metric:last-child {\n    border-bottom: none;\n  }\n\n  .metric-label {\n    font-size: 0.72rem;\n    text-transform: uppercase;\n    letter-spacing: 0.4em;\n    color: rgba(15, 76, 117, 0.45);\n    margin-bottom: 0.35rem;\n  }\n\n  .metric-value {\n    font-size: 1.05rem;\n    color: #0f4c75;\n    font-weight: 500;\n  }\n\n  .healing-table {\n    border-collapse: collapse;\n    width: 100%;\n    min-width: 520px;\n  }\n\n  .healing-table th,\n  .healing-table td {\n    text-align: left;\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid rgba(15, 76, 117, 0.08);\n    font-size: 0.9rem;\n    color: #0f4c75;\n  }\n\n  .healing-table thead th {\n    font-size: 0.75rem;\n    letter-spacing: 0.35em;\n    text-transform: uppercase;\n    color: rgba(15, 76, 117, 0.45);\n    border-bottom: 1px solid rgba(15, 76, 117, 0.15);\n  }\n\n  .healing-select {\n    background: rgba(255, 255, 255, 0.9);\n    border: 1px solid rgba(15, 76, 117, 0.15);\n    border-radius: 999px;\n    padding: 0.35rem 0.75rem;\n    font-size: 0.85rem;\n    color: #0f4c75;\n  }\n\n  .healing-subtle-panel ul li span:last-child,\n  .healing-subtle-panel ul li strong {\n    font-weight: 600;\n  }\n\n  .healing-subtle-panel ul li strong {\n    color: #0f4c75;\n  }\n\n  .healing-subtle-panel ul li span:first-child {\n    color: rgba(15, 76, 117, 0.6);\n  }\n\n  .healing-subtle-panel ul li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .healing-background .healing-card h1,\n  .healing-background h2,\n  .healing-background h3,\n  .healing-background h4 {\n    color: #0f4c75;\n  }\n\n  .healing-select:focus,\n  .healing-pill-tab:focus,\n  .healing-primary-btn:focus,\n  .healing-secondary-btn:focus {\n    outline: 2px solid rgba(76, 184, 196, 0.5);\n    outline-offset: 2px;\n  }\n\n  .healing-card .metric-value {\n    font-family: 'Inter', 'Segoe UI', sans-serif;\n  }\n\n  .healing-card,\n  .healing-subtle-panel {\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n  }\n\n  .healing-card:hover,\n  .healing-subtle-panel:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 35px 60px rgba(13, 38, 59, 0.08);\n  }\n\n  .healing-card .metric-label {\n    font-family: 'Inter', 'Segoe UI', sans-serif;\n  }\n\n  .healing-tab-content {\n    background: rgba(255, 255, 255, 0.92);\n    border-radius: 1.25rem;\n    border: 1px solid rgba(15, 76, 117, 0.06);\n  }\n\n  .healing-tab-content + .healing-tab-content {\n    margin-top: 1.5rem;\n  }\n\n  .healing-muted-text {\n    color: rgba(15, 76, 117, 0.6);\n  }\n\n  .healing-ink,\n  .text-healing-ink {\n    color: #0f4c75;\n  }\n\n  .text-healing-ink-60 {\n    color: rgba(15, 76, 117, 0.6);\n  }\n\n  .text-healing-ink-70 {\n    color: rgba(15, 76, 117, 0.7);\n  }\n\n  .text-healing-ink-80 {\n    color: rgba(15, 76, 117, 0.8);\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
